import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { Emails } from '../_models/emails.model';

const API_URL = environment.urlPages;

@Injectable({
    providedIn: 'root',
})

export class EmailsService {

    httpOptions = {
        headers: new HttpHeaders(
          {
            'Content-Type': 'application/json'
          }
        )
    };
    constructor(private http: HttpClient) { }

    getEmailsByClaimId(emailId: number): Observable<Emails> {
        let url: string = `${environment.urlWS}${RestRoutes.EMAILS_GET}/${emailId}`;
        //console.log(url)
        return this.http.get<Emails>(url, this.httpOptions);
    }

}
